import { render } from "./scroll.vue?vue&type=template&id=814d893e&scoped=true"
import script from "./scroll.vue?vue&type=script&lang=js"
export * from "./scroll.vue?vue&type=script&lang=js"

import "./scroll.vue?vue&type=style&index=0&id=814d893e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814d893e"]])

export default __exports__